export default __webpack_public_path__ + "static/media/sadFace.728eaf14.svg";